import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { finalize } from 'rxjs/operators';
import { SecurityQuestionsAndAnswers } from '../models/security-questions-and-answers.model';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:
  `
    <div class="login-card" *ngIf="showPageContent">
      <!-- SECURITY QUESTIONS -->
      <div class="section-title"> {{heading}}
        <div *ngIf="questionNumber">
          <label class="question-no-label">{{ questionNumber }}</label>
        </div>
      </div>
         
      <div *ngIf="showVerificationDetails">
        <ul class="bullet-point-list">
            <li>Provide the National ID number/Passport number you entered when you registered for an account.</li>
            <li>Answer the security questions, some of which you provided during the registration process.</li>
        </ul>
        <!-- BUTTON -->
        <div class="btns">
            <button class="set-authorization-btn"
                (click)="proccedToVerification()">
                Procced
            </button>
        </div>
      </div>

      <div *ngIf="showIdentityNumberInput">
        <!-- National ID number/Passport number -->
        <div class="field">
          <label class="field-label">National ID number/Passport number</label>
          <input type="text" class="input" 
            [(ngModel)]="identityNumber">
          <div class="validation-message" *ngIf="identityNumberValidationMessage">
            {{identityNumberValidationMessage}}
          </div>
        </div>
        <!-- BUTTON -->
        <div class="btns">
          <button
            class="set-authorization-btn"
            [disabled]="isLoading || !identityNumber?.trim()"
            (click)="verifyIdentityNumber()">

            <span *ngIf="!isLoading">Submit</span>
            <span *ngIf="isLoading" class="spinner"></span>

          </button>
        </div>
      </div>
      
      <!-- Question 1 -->
      <div *ngIf="showQuestion1">
        <div class="question-block">
          <div class="question-row">
            <label class="question-label">{{ securityQuestionsAndAnswers[0].question.question }}?</label>
          </div>
          <div class="validation-message" *ngIf="question1ValidationMessage">
            {{question1ValidationMessage}}
          </div>
          <div class="answer-option" *ngFor="let p of securityQuestionsAndAnswers[0].answers.$values"
            [class.selected]="selectedAnswer === p"
            (click)="selectAnswer1(p)">
            <div class="payment-option-left">
              <span>{{ p }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Question 2 -->
      <div *ngIf="showQuestion2">
        <div class="question-block">
          <div class="question-row">
            <label class="question-label">{{ securityQuestionsAndAnswers[1].question.question }}?</label>
          </div>
          <div class="validation-message" *ngIf="question2ValidationMessage">
            {{question2ValidationMessage}}
          </div>
          <div class="answer-option" *ngFor="let p of securityQuestionsAndAnswers[1].answers.$values"
            [class.selected]="selectedAnswer === p"
            (click)="selectAnswer2(p)">
            <div class="payment-option-left">
              <span>{{ p }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Question 3 -->
      <div *ngIf="showQuestion3">
        <div class="question-block">
          <div class="question-row">
            <label class="question-label">{{ securityQuestionsAndAnswers[2].question.question }}?</label>
          </div>
          <div class="validation-message" *ngIf="question3ValidationMessage">
            {{question3ValidationMessage}}
          </div>
          <div class="answer-option" *ngFor="let p of securityQuestionsAndAnswers[2].answers.$values"
            [class.selected]="selectedAnswer === p"
            (click)="selectAnswer3(p)">
            <div class="payment-option-left">
            <span>{{ p }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Question 4 -->
      <div *ngIf="showQuestion4">
        <div class="question-block">
          <div class="question-row">
            <label class="question-label">{{ securityQuestionsAndAnswers[3].question.question }}?</label>
          </div>
          <div class="validation-message" *ngIf="question4ValidationMessage">
            {{question4ValidationMessage}}
          </div>
          <div class="answer-option" *ngFor="let p of securityQuestionsAndAnswers[3].answers.$values"
            [class.selected]="selectedAnswer === p"
            (click)="selectAnswer4(p)">
            <div class="payment-option-left">
            <span>{{ p }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Question 5 -->
      <div *ngIf="showQuestion5">
        <div class="question-block">
          <div class="question-row">
            <label class="question-label">{{ securityQuestionsAndAnswers[4].question.question }}?</label>
          </div>
          <div class="validation-message" *ngIf="question5ValidationMessage">
            {{question5ValidationMessage}}
          </div>
          <div class="answer-option" *ngFor="let p of securityQuestionsAndAnswers[4].answers.$values"
            [class.selected]="selectedAnswer === p"
            (click)="selectAnswer5(p)">
            <div class="payment-option-left">
              <span>{{ p }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Question 6 -->
      <div *ngIf="showQuestion6">
        <div class="question-block">
          <div class="question-row">
            <label class="question-label">{{ securityQuestionsAndAnswers[5].question.question }}?</label>
          </div>
          <div class="validation-message" *ngIf="question6ValidationMessage">
            {{question6ValidationMessage}}
          </div>
          <div class="answer-option" *ngFor="let p of securityQuestionsAndAnswers[5].answers.$values"
            [class.selected]="selectedAnswer === p"
            (click)="selectAnswer6(p)">
            <div class="payment-option-left">
              <span>{{ p }}</span>
            </div>
          </div>
        </div>
      </div>
   
      <div *ngIf="showResetPin">
        <!-- PIN INPUT -->
        <p class="pin-text">
            Create your 4-digit PIN.
        </p>
        <div class="pin-warning-text"  *ngIf="pinValidationMessage">
            {{pinValidationMessage}}
        </div>
        <div class="pin-wrapper">
          <input
          #pinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="loginPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onPinChange($event)">

          <div class="pin-wrapper">
            <!-- Hidden input -->
            <input
            #pinInput
            class="hidden-pin-input"
            type="password"
            inputmode="numeric"
            maxlength="4"
            autocomplete="one-time-code"
            [(ngModel)]="loginPin"
            (keydown)="allowOnlyNumbers($event)"
            (ngModelChange)="onPinChange($event)">

            <!-- Click anywhere to focus -->
            <div class="pin-display" (click)="pinInput.focus()">
              <div class="pin-circle"
                  [class.filled]="loginPin.length > 0"
                  [class.active]="loginPin.length === 0">
                  {{ loginPin.length > 0 ? '•' : '' }}
              </div>

              <div class="pin-circle"
                  [class.filled]="loginPin.length > 1"
                  [class.active]="loginPin.length === 1">
                {{ loginPin.length > 1 ? '•' : '' }}
              </div>

              <div class="pin-circle"
                  [class.filled]="loginPin.length > 2"
                  [class.active]="loginPin.length === 2">
                {{ loginPin.length > 2 ? '•' : '' }}
              </div>

              <div class="pin-circle"
                  [class.filled]="loginPin.length > 3"
                  [class.active]="loginPin.length === 3">
                {{ loginPin.length > 3 ? '•' : '' }}
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- CONFIRM PIN INPUT -->
        <div  *ngIf="confirmPinSection">
    <div class="back-btn" (click)="return()">
        ←
      </div>
        <p class="pin-text">
          Confirm your 4-digit PIN.
        </p>
        <div class="pin-warning-text"  *ngIf="confirmPinValidationMessage">
          {{confirmPinValidationMessage}}
        </div>
        <div class="pin-wrapper">
          <input
          #pinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="confirmPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onConfirmPinChange($event)">

          <div class="pin-wrapper">
            <!-- Hidden input -->
            <input
            #confirmPinInput
            class="hidden-pin-input"
            type="password"
            inputmode="numeric"
            maxlength="4"
            autocomplete="one-time-code"
            [(ngModel)]="confirmPin"
            (keydown)="allowOnlyNumbers($event)"
            (ngModelChange)="onConfirmPinChange($event)">

            <!-- Click anywhere to focus -->
            <div class="pin-display" (click)="confirmPinInput.focus()">
              <div class="pin-circle"
                [class.filled]="confirmPin.length > 0"
                [class.active]="confirmPin.length === 0">
                {{ confirmPin.length > 0 ? '•' : '' }}
              </div>
              <div class="pin-circle"
                [class.filled]="confirmPin.length > 1"
                [class.active]="confirmPin.length === 1">
                {{ confirmPin.length > 1 ? '•' : '' }}
              </div>
              <div class="pin-circle"
                [class.filled]="confirmPin.length > 2"
                [class.active]="confirmPin.length === 2">
                {{ confirmPin.length > 2 ? '•' : '' }}
              </div>
              <div class="pin-circle"
                [class.filled]="confirmPin.length > 3"
                [class.active]="confirmPin.length === 3">
                {{ confirmPin.length > 3 ? '•' : '' }}
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <div class="btns">
          <button class="set-authorization-btn"
            (click)="saveAuthorizationPin()"
            [disabled]="isLoading || loginPin.length !== 4 ||
            confirmPin.length !== 4 ||
            loginPin !== confirmPin ||
              pinValidationMessage ||
            confirmPinValidationMessage">
            <span *ngIf="!isLoading">Save</span>
            <span *ngIf="isLoading" class="spinner"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- SUCCESS ALERT-->
    <div class="overlay" *ngIf="showSuccessAlert">
      <div class="alert-modal">
        <div class="success-icon">
        ✓
        </div>
        <div class="alert-text">
          {{successAlertMessage}}
        </div>
      </div>
    </div>

     <!-- ERROR ALERT-->
    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Close
          </button>
        </div>
      </div>
    </div>
  `
})
export class ForgotPinPage{
  userId = '';
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  securityQuestionsAndAnswers: SecurityQuestionsAndAnswers[] = [];
  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) {}

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('userId') ?? '';
    if (!this.userId) {
      this.errorMessage = 'Invalid link';
      this.showErrorPopup = true;
      this.showVerificationDetails = false
      return;
    }
    this.getSecurityQuestionsAndAnswers();
  }
  getSecurityQuestionsAndAnswers() {
    this.authService
    .getSecurityQuestionsAndAnswers(this.userId, 'forgotPin')
    .subscribe({
        next: response => {
          console.log(response);
           this.securityQuestionsAndAnswers = response.securityQuestionsAndAnswers
            .securityQuestionsAndAnswers
            .$values;

            if(response.message)
              this.identityNumberValidationMessage = response.message;
        },
        error: err => {
          this.showPageContent = false;
         if (err.status === 304 || err.status === 403){
            window.location.href = this.whatsAppUrl;
          }
          else{
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            return;
          }
        }
      },
    );
  }
  // =====================================================
  // DECLARATIONS
  // =====================================================
    errorMessage = '';
    showErrorPopup = false;
     heading = 'Account Verification';
    showVerificationDetails = true;
    questionNumber = '';
    showResetPin = false;
    showSuccessAlert = false;
    showQuestion1 = false;
    showQuestion2 = false;
    showQuestion3 = false;
    showQuestion4 = false;
    showQuestion5 = false;
    showQuestion6 = false;
    question1ValidationMessage = '';
    question2ValidationMessage = '';
    question3ValidationMessage = '';
    question4ValidationMessage = '';
    question5ValidationMessage = '';
    question6ValidationMessage = '';
    selectedQuestions: string[] = [];
    answers = ['', '', ''];
    loginPin = '';
    confirmPin = '';
    pinValidationMessage = '';
    confirmPinValidationMessage = '';
    successAlertMessage = 'Answer verified successfully';
    identityNumberValidationMessage = '';
    identityNumber = '';
    showIdentityNumberInput = false;
    showPageContent = true;
    confirmPinSection = false

  // =====================================================
  // METHODS
  // =====================================================
  verifyIdentityNumber(){
    this.isLoading = true;

    this.authService.postIdentityNumber(this.userId, this.identityNumber)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          console.log(response);
          this.showIdentityNumberInput = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert = true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);

          this.showQuestion1 = true;
          this.questionNumber = 'Question (1 of 6)';
          
        },
        error: err => {
          if (err.status === 401) {
            this.identityNumberValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  closeErrorPopup() {
    window.location.href = this.whatsAppUrl;
  }
  proccedToVerification() {
   this.showVerificationDetails = false;
   this.showIdentityNumberInput = true;
  }
  selectAnswer1(answer:string){
    this.question1ValidationMessage = '';
    this.isLoading = true;
    this.authService.postSecurityAnswer(this.userId, 
                                        this.securityQuestionsAndAnswers[0].question.questionId, 
                                        answer)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          this.showQuestion1 = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert= true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);
          
          this.showQuestion2 = true;
          this.questionNumber = 'Question (2 of 6)';
        },
        error: err => {
          if (err.status === 401) {
            this.question1ValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  selectAnswer2(answer:string){
    this.question2ValidationMessage = '';
    this.isLoading = true;
    this.authService.postSecurityAnswer(this.userId, 
                                        this.securityQuestionsAndAnswers[1].question.questionId, 
                                        answer)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          this.showQuestion2 = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert= true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);
          
          this.showQuestion3 = true;
          this.questionNumber = 'Question (3 of 6)';
        },
        error: err => {
          if (err.status === 401) {
            this.question2ValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  selectAnswer3(answer:string){
   this.question3ValidationMessage = '';
    this.isLoading = true;
    this.authService.postSecurityAnswer(this.userId, 
                                        this.securityQuestionsAndAnswers[2].question.questionId, 
                                        answer)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          this.showQuestion3 = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert= true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);
          
          this.showQuestion4 = true;
          this.questionNumber = 'Question (4 of 6)';
        },
        error: err => {
          if (err.status === 401) {
            this.question3ValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  selectAnswer4(answer:string){
    this.question4ValidationMessage = '';
    this.isLoading = true;
    this.authService.postSecurityAnswer(this.userId, 
                                        this.securityQuestionsAndAnswers[3].question.questionId, 
                                        answer)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          this.showQuestion4 = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert= true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);
          
          this.showQuestion5 = true;
          this.questionNumber = 'Question (5 of 6)';
        },
        error: err => {
          if (err.status === 401) {
            this.question4ValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  selectAnswer5(answer:string){
    this.question5ValidationMessage = '';
    this.isLoading = true;
    this.authService.postSecurityAnswer(this.userId, 
                                        this.securityQuestionsAndAnswers[4].question.questionId, 
                                        answer)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          this.showQuestion5 = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert= true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);
          
          this.showQuestion6 = true;
          this.questionNumber = 'Question (6 of 6)';
        },
        error: err => {
          if (err.status === 401) {
            this.question5ValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  selectAnswer6(answer:string){
    this.question6ValidationMessage = '';
    this.isLoading = true;
    this.authService.postSecurityAnswer(this.userId, 
                                        this.securityQuestionsAndAnswers[5].question.questionId, 
                                        answer)
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
        next: response => {
          this.showQuestion6 = false;

          this.successAlertMessage = response.message;
          this.showSuccessAlert= true;
          setTimeout(()=> this.showSuccessAlert = false, 1500);
          
          this.showResetPin = true;
          this.heading = 'Reset PIN'
          this.questionNumber = '';
        },
        error: err => {
          if (err.status === 401) {
            this.question6ValidationMessage = err.error?.message;
          }
          else{
             this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  saveAuthorizationPin() {
     this.isLoading = true;
        this.authService
        .postAuthorizationPin(this.userId, this.loginPin, 'forgot')
        .pipe(
          finalize(() => this.isLoading = false)
        )
        .subscribe({
          next: response => {
             if (response.status === 201) {
                window.location.href = this.whatsAppUrl;
             }
            this.successAlertMessage = 'PIN reset successfully.';
            this.showSuccessAlert = true;

            setTimeout(() => {
              this.showSuccessAlert = false;

              this.router.navigateByUrl(
                '/login/' + this.userId,
                { replaceUrl: true }
              );
            }, 1500);
          },
          error: err => {
            if (err.status === 409) {
              this.pinValidationMessage = err.error?.message;
               this.showResetPin = true;
              this.confirmPinSection = false;
              this.loginPin = '';
              this.heading = 'Reset PIN'
              return;
            }

            this.showPageContent = false;
            this.errorMessage = err.error?.message ?? 'Unable to save security questions.';
            this.showErrorPopup = true;
          }
        });
  }

  return(){
    this.showResetPin = true;
        this.confirmPinSection = false;
        this.loginPin = '';
        this.heading = 'Reset PIN';
  }
  onPinChange(value: string): void {
    this.loginPin = value.replace(/\D/g, '').slice(0, 4);
    const validation = this.validatePin(this.loginPin);
    if(validation.isValid){
        this.showResetPin = false;
        this.confirmPinSection = true;
        this.confirmPin = '';
        this.confirmPinValidationMessage = ''; 
        this.heading = '';
        return;
    }
    this.pinValidationMessage = validation.message;
    this.validateConfirmPin();
  }
  onConfirmPinChange(value: string): void {
    this.confirmPin = value.replace(/\D/g, '').slice(0, 4);
    this.validateConfirmPin();
  }
  validateConfirmPin() {
    this.confirmPinValidationMessage = '';
    const validation = this.validatePin(this.confirmPin);

    if (!validation.isValid) {
      this.confirmPinValidationMessage = validation.message;
      return;
    }
    if (this.confirmPin.length === 4 &&this.loginPin !== this.confirmPin) {
      this.confirmPinValidationMessage = 'PINs do not match.';
    }
  }
  validatePin(pin: string): { isValid: boolean; message: string } {
    if (pin.length !== 4) {
      return { isValid: false, message: '' };
    }
    // 1111, 2222, 9999...
    if (/^(\d)\1{3}$/.test(pin)) {
      return {
        isValid: false,
        message: 'PIN cannot contain the same digit four times.'
      };
    }
    // Ascending (1234, 4567)
    let ascending = true;
    for (let i = 1; i < pin.length; i++) {
      if (+pin[i] !== +pin[i - 1] + 1) {
        ascending = false;
        break;
      }
    }
    //
    if (ascending) {
      return {
        isValid: false,
        message: 'PIN cannot be sequential.'
      };
    }
    // Descending (4321, 9876)
    let descending = true;
    for (let i = 1; i < pin.length; i++) {
      if (+pin[i] !== +pin[i - 1] - 1) {
        descending = false;
        break;
      }
    }
    //
    if (descending) {
      return {
        isValid: false,
        message: 'PIN cannot be sequential.'
      };
    }
    // Same forwards and backwards (1221, 3443, 1001)
    if (pin === pin.split('').reverse().join('')) {
      return {
        isValid: false,
        message: 'PIN cannot be the same in reverse.'
      };
    }
    // Repeating pattern (1212, 3434, 9090)
    if (pin[0] === pin[2] && pin[1] === pin[3]) {
      return {
        isValid: false,
        message: 'PIN cannot contain repeating patterns.'
      };
    }
    // Two pairs (1122, 7788)
    if (pin[0] === pin[1] && pin[2] === pin[3]) {
      return {
        isValid: false,
        message: 'PIN cannot contain repeated pairs.'
      };
    }
    return {
      isValid: true,
      message: ''
    };
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];
    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }
    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}